<template>
  <v-text-field
    v-model="value.value"
    :label="value == null ? '' : value.caption"
    :name="value == null ? '' : value.name"
    :clearable="true"
    :readonly="value == null ? false : value.readonly"
    :required="value == null ? false : value.required"
    :rules="rules"
    type="number"
    onkeydown="javascript: return event.keyCode == 69 ? false : true"
  >
    <template #label>
      <span v-if="value.required" class="red--text"><strong>* </strong></span
      >{{ value.caption }}
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "MyFormNumber",
  props: {
    value: {
      type: Object,
      default: function() {
        return { name: "MyFormInputNotSet", value: 0, caption: "not set" };
      },
    },
  },
  computed: {
    rules() {
      const rules = [];

      if (this.value.required) {
        const rule = (v) => !!v || this.$i18n.t("common.required");

        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    filterKey(e) {
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },

    // This can also prevent copy + paste invalid character
    filterInput(e) {
      console.log("adsfadf");
      e.target.value = e.target.value.replace(/[^0-9]+/g, "");
    },
  },
};
</script>

<style scoped></style>
